import createIcon from '../../createIcon';

/**
 * @component @name SafetyCheck
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkw0IDVWMTEuMDlDNCAxNi4xNCA3LjQxIDIwLjg1IDEyIDIyQzE2LjU5IDIwLjg1IDIwIDE2LjE0IDIwIDExLjA5VjVMMTIgMlpNMTIgMTdDOS4yNCAxNyA3IDE0Ljc2IDcgMTJDNyA5LjI0IDkuMjQgNyAxMiA3QzE0Ljc2IDcgMTcgOS4yNCAxNyAxMkMxNyAxNC43NiAxNC43NiAxNyAxMiAxN1pNMTMuNjUgMTQuMzVMMTEuNSAxMi4yVjlIMTIuNVYxMS43OUwxNC4zNSAxMy42NEwxMy42NSAxNC4zNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SafetyCheck = createIcon('SafetyCheck', [
  [
    'path',
    {
      d: 'M12 2L4 5V11.09C4 16.14 7.41 20.85 12 22C16.59 20.85 20 16.14 20 11.09V5L12 2ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17ZM13.65 14.35L11.5 12.2V9H12.5V11.79L14.35 13.64L13.65 14.35Z',
      key: '4khc1a',
    },
  ],
]);

export default SafetyCheck;
